/**
  * @func getInhabitance
  * @author Brian Nunez <brian.j.nunez1@aexp.com>
  * @param {Object} values
  * @param {string} values.placeOfBirth
  * @param {string} values.nationality
  * @returns {{
*  type: 'BIRTH' | 'NATIONALITY',
*  city?: string,
*  country?: string,
* }[] | null}
*/
function getInhabitance({
  placeOfBirth,
  nationality,
}) {
  const inhabitance = [];

  if (placeOfBirth) {
    inhabitance.push({
      type: 'BIRTH',
      city: placeOfBirth,
    });
  }

  if (nationality) {
    inhabitance.push({
      type: 'NATIONALITY',
      country: nationality,
    });
  }

  return inhabitance.length > 0 ? inhabitance : null;
}

export default getInhabitance;
